<template>
    <div class="settings">
        <Navbar />
        <div class="mt-5 pt-5 kova-width">
            <div class="text-left pl-0 pl-md-5 mt-3 ml-5 mb-4" @click="$router.back()">
                <a-icon class="mr-1" type="arrow-left" />
                <span class="go-back">Go Back</span>
            </div>
            <div class="px-1 px-md-4 px-lg-5 mx-lg-4 my-5">
                <div class="bg-light border p-2 p-md-4 add-rounded">
                    <h5 class="font-weight-bolder text-left">Settings</h5>

                    <a-tabs :activeKey="activeKey" @change="callback">
                        <a-tab-pane tab="Profile" :key="1">
                            <div class="mt-4">
                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-5 col-lg-4">
                                        <div>
                                            <div class="border add-rounded p-2">
                                                <div class="add-rounded bg-white py-4">
                                                    <img
                                                        :src="imageUrl"
                                                        alt=""
                                                        class="rounded-circle img-height"
                                                        v-if="imageUrl"
                                                    />
                                                    <img
                                                        src="../assets/kovatek/user.png"
                                                        alt=""
                                                        class="rounded-circle img-height"
                                                        v-else
                                                    />
                                                    <div class="d-flex mt-3 px-lg-3 justify-content-center">
                                                        <a-upload
                                                            @change="upload"
                                                            :show-upload-list="false"
                                                            :before-upload="beforeUpload"
                                                            class="mt-1"
                                                        >
                                                            <span
                                                                class="py-2 px-3 light-blue kova-text rounded font-weight-bolder ctrl-font pointer"
                                                                style="white-space:nowrap"
                                                            >
                                                                Upload new photo
                                                            </span>
                                                        </a-upload>
                                                        <a-popconfirm
                                                            title="Are you sure? You won't be able to revert this action"
                                                            ok-text="Yes"
                                                            cancel-text="No"
                                                            @confirm="deleteAvatar"
                                                        >
                                                            <span
                                                                v-if="imageUrl"
                                                                class="font-weight-bolder bg-light py-2 px-3 rounded ctrl-font ml-3 pointer"
                                                            >
                                                                Remove
                                                            </span>
                                                        </a-popconfirm>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-3 pb-3">
                                                <a-tooltip placement="topLeft">
                                                    <template slot="title">
                                                        <span
                                                            ><a-icon
                                                                class="mr-2"
                                                                type="info-circle"
                                                                style="position:relative; bottom: 3px;font-size: 16px;"
                                                            />
                                                            {{ copied ? 'Copied to clipboard' : 'click to copy' }}
                                                        </span>
                                                    </template>
                                                    <span class="ml-2">
                                                        <span
                                                            @mouseover="copied = false"
                                                            @click="copy(portfolioLink)"
                                                            class="kova-id px-3 py-1 text-white font-weight-bolder"
                                                        >
                                                            {{ portfolioLink }}</span
                                                        >
                                                    </span>
                                                </a-tooltip>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-7 col-lg-8">
                                        <div class="border add-rounded p-4">
                                            <div class="row">
                                                <div :class="` ${githubName ? 'col-md-9' : 'col-md-12'} col-sm-12`">
                                                    <h6
                                                        class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font"
                                                    >
                                                        Username
                                                    </h6>
                                                    <input
                                                        class="ml-lg-1 ant-input ant-input-lg"
                                                        placeholder="Enter a unique name"
                                                        v-model="inputtedUsername"
                                                        required
                                                        :style="[cursorDisabled]"
                                                    />
                                                </div>
                                                <div v-if="githubName" class="col-md-3 col-sm-12 mt-lg-5">
                                                    <label
                                                        for="githubName"
                                                        class="ant-checkbox-wrapper"
                                                        :style="[cursorDisabled]"
                                                        @click="onChange"
                                                    >
                                                        <span class="ant-checkbox">
                                                            <input
                                                                id="githubName"
                                                                type="checkbox"
                                                                class="ant-checkbox-input"
                                                                :value="userUsesGithubName"
                                                            />
                                                            <span class="ant-checkbox-inner"></span>
                                                        </span>
                                                        <span> Use Github Name </span>
                                                    </label>
                                                </div>
                                                <div class="col-md-6 col-sm-12">
                                                    <h6
                                                        class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font"
                                                    >
                                                        First Name
                                                    </h6>
                                                    <a-input
                                                        size="large"
                                                        class="ml-lg-1"
                                                        v-model="settingsData.Firstname"
                                                        required
                                                        :style="[cursorDisabled]"
                                                    />
                                                </div>
                                                <div class="col-md-6 col-sm-12">
                                                    <h6
                                                        class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font"
                                                    >
                                                        Surname
                                                    </h6>
                                                    <a-input
                                                        size="large"
                                                        class="ml-lg-1"
                                                        v-model="settingsData.Surname"
                                                        :style="[cursorDisabled]"
                                                        required
                                                    />
                                                </div>

                                                <div class="col-md-6 col-sm-12">
                                                    <h6
                                                        class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font"
                                                    >
                                                        Email
                                                    </h6>
                                                    <div class="d-flex">
                                                        <a-input
                                                            :style="[cursorDisabled]"
                                                            size="large"
                                                            v-model="settingsData.Email"
                                                            required
                                                        />
                                                        <img
                                                            v-if="emailVerified"
                                                            class="ml-1 ml-md-2 mb-1 mt-2"
                                                            style="height:22px;"
                                                            src="../assets/kovatek/correct.svg"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>

                                                <div class="col-md-6 col-sm-12">
                                                    <h6
                                                        class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font"
                                                    >
                                                        Phone Number
                                                    </h6>
                                                    <div class="d-flex">
                                                        <vue-tel-input
                                                            enabledCountryCode
                                                            validCharactersOnly
                                                            @input="showPhone"
                                                            required
                                                            :inputOptions="{
                                                                showDialCode: true,
                                                                tabindex: 1,
                                                            }"
                                                            :style="[cursorDisabled]"
                                                            inputClasses=" ant-input ant-input-lg"
                                                            v-model.trim="settingsData.Phone"
                                                        ></vue-tel-input>
                                                        <img
                                                            v-if="phoneVerified"
                                                            class="ml-1 ml-md-2 mb-1 mt-2"
                                                            style="height:22px;"
                                                            src="../assets/kovatek/correct.svg"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="d-flex mt-4 px-lg-3 justify-content-start">
                                                <button
                                                    class="py-2 px-3 border-0 kova-bg text-white rounded font-weight-bolder ctrl-font pointer"
                                                    style="white-space:nowrap"
                                                    @click="updateProfile"
                                                    :style="[cursorDisabled]"
                                                >
                                                    Save changes
                                                </button>
                                                <button
                                                    class="font-weight-bolder border-0 bg-light py-2 px-3 rounded ctrl-font ml-3 pointer"
                                                    :style="[cursorDisabled]"
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a-tab-pane>
                        <a-tab-pane tab="Password & Security" :key="2" forceRender>
                            <div class="mt-4">
                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <div class="border add-rounded p-4">
                                            <h6 class="font-weight-bolder text-left mb-4">
                                                Change Password
                                            </h6>
                                            <div>
                                                <h6
                                                    class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font"
                                                >
                                                    Old Password
                                                </h6>
                                                <div class="d-flex">
                                                    <a-input
                                                        size="large"
                                                        type="password"
                                                        class="ml-1 font-weight-bolder"
                                                        :style="[cursorDisabled]"
                                                        v-model="oldPassword"
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div>
                                                <h6
                                                    class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font"
                                                >
                                                    New Password
                                                </h6>
                                                <div class="d-flex">
                                                    <a-input
                                                        size="large"
                                                        type="password"
                                                        class="ml-1 font-weight-bolder"
                                                        :style="[cursorDisabled]"
                                                        v-model="newPassword"
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div>
                                                <h6
                                                    class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font"
                                                >
                                                    Confirm Password
                                                </h6>
                                                <div class="d-flex">
                                                    <a-input
                                                        size="large"
                                                        type="password"
                                                        class="ml-1 font-weight-bolder"
                                                        v-model="confirmPassword"
                                                        :style="[cursorDisabled]"
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div class="d-flex mt-4 px-lg-3 justify-content-start">
                                                <button
                                                    class="py-2 px-3 kova-bg border-0 text-white rounded font-weight-bolder ctrl-font pointer"
                                                    style="white-space:nowrap"
                                                    :style="[cursorDisabled]"
                                                    @click="updatePassword"
                                                >
                                                    Save changes
                                                </button>
                                                <button
                                                    :style="[cursorDisabled]"
                                                    class="font-weight-bolder border-0 bg-light py-2 px-3 rounded ctrl-font ml-3 pointer"
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <div class="border add-rounded p-4">
                                            <div class="d-flex">
                                                <div class="text-left mr-auto">
                                                    <h6 class="font-weight-bolder text-left">
                                                        Two Factor Authentication
                                                    </h6>
                                                </div>
                                                <div>
                                                    <div class="input-group mb-3">
                                                        <!-- <input type="button" value="Add More" class="btn-kovatek new-bank py-1 px-3" />
                                      <div class="input-group-append btn-kovatek plus-btn-icon py-1 px-2">
                                          <a-icon type="plus" style="position: relative;bottom: -3px;"/>
                                      </div> -->
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="d-flex">
                                                    <a-input
                                                        size="large"
                                                        class="ml-1 font-weight-bolder"
                                                        value="Google"
                                                        disabled
                                                    />
                                                    <img
                                                        v-if="emailVerified"
                                                        class="ml-1 ml-md-2 mb-1 mt-2"
                                                        style="height:22px;"
                                                        src="../assets/kovatek/correct.svg"
                                                        alt=""
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <div class="d-flex mt-3">
                                                    <a-input
                                                        size="large"
                                                        class="ml-1 font-weight-bolder"
                                                        value="Github"
                                                        disabled
                                                    />
                                                    <img
                                                        v-if="emailVerified"
                                                        class="ml-1 ml-md-2 mb-1 mt-2"
                                                        style="height:22px;"
                                                        src="../assets/kovatek/correct.svg"
                                                        alt=""
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex mt-5 px-lg-3 justify-content-end">
                                            <span
                                                class="py-2 px-3 light-blue kova-text rounded font-weight-bolder ctrl-font pointer"
                                                style="white-space:nowrap"
                                                >Delete my Account</span
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a-tab-pane>

                        <a-tab-pane tab="Card & Payments" forceRender :key="3">
                            <div class="bg-light border p-2 p-md-4">
                                <div class="row">
                                    <div class="col-12 col-md-12 col-lg-6">
                                        <h5 class="font-weight-bolder text-left">
                                            Billing and Payments
                                        </h5>
                                        <h6 class="text-left mt-4">Current Balance</h6>
                                        <h6 class="font-weight-bolder text-left">
                                            Your balance is ${{ formatAmount(wallet.AvailableBalance) }}
                                        </h6>
                                    </div>
                                    <div class="col-12 col-md-12 col-lg-6">
                                        <h6 class="text-left mt-5">Current Balance</h6>
                                        <h6 class="font-weight-bolder text-left">
                                            Your balance is 0.00 BTC
                                        </h6>
                                    </div>
                                </div>
                            </div>

                            <div class="mx-3 add-rounded">
                                <div class="row">
                                    <div class="col-12 col-md-12 col-lg-6 bg-light">
                                        <div class="row">
                                            <div class="col-12 col-md-12 col-lg-11 border border-top-0">
                                                <form @submit.prevent="withdraw">
                                                    <div class="my-4">
                                                        <div class="d-flex">
                                                            <div class="text-left mr-auto">
                                                                <h6 class="font-weight-bolder text-left">
                                                                    {{
                                                                        !settingsData.AccountName
                                                                            ? 'Account Details'
                                                                            : 'Withdrawal'
                                                                    }}
                                                                </h6>
                                                            </div>
                                                        </div>

                                                        <div class="px-1 px-md-3 ">
                                                            <h6
                                                                class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font"
                                                            >
                                                                Bank
                                                            </h6>
                                                            <a-select
                                                                class="ml-1"
                                                                v-model="account.account_bank"
                                                                :disabled="loading"
                                                                size="large"
                                                                :style="[cursorDisabled]"
                                                                show-search
                                                                placeholder="Select Bank"
                                                            >
                                                                <a-select-option value="UBA">
                                                                    UBA
                                                                </a-select-option>
                                                            </a-select>

                                                            <h6
                                                                class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font"
                                                                :disabled="loading"
                                                            >
                                                                Account Number
                                                            </h6>
                                                            <a-input
                                                                v-model="account.account_number"
                                                                :disabled="loading"
                                                                type="number"
                                                                class="ml-1"
                                                                :style="[cursorDisabled]"
                                                                size="large"
                                                            />

                                                            <template v-if="!!settingsData.AccountName">
                                                                <h6
                                                                    class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font"
                                                                >
                                                                    Amount
                                                                </h6>
                                                                <a-input-group compact class="ml-1">
                                                                    <a-select
                                                                        size="large"
                                                                        class="text-left w-25"
                                                                        :disabled="loading"
                                                                        v-model="account.currency"
                                                                        :style="[cursorDisabled]"
                                                                    >
                                                                        <a-select-option
                                                                            v-for="{ currency } in filteredCurrencies"
                                                                            :key="currency + 'qs3'"
                                                                            :value="currency"
                                                                        >
                                                                            {{ currency }}
                                                                        </a-select-option>
                                                                    </a-select>
                                                                    <a-input-number
                                                                        :disabled="loading"
                                                                        class="w-75 font-weight-bolder"
                                                                        size="large"
                                                                        placeholder="0"
                                                                        :formatter="
                                                                            value =>
                                                                                `${value}`.replace(
                                                                                    /\B(?=(\d{3})+(?!\d))/g,
                                                                                    ',',
                                                                                )
                                                                        "
                                                                        :style="[cursorDisabled]"
                                                                        :parser="
                                                                            value => value.replace(/\$\s?|(,*)/g, '')
                                                                        "
                                                                        v-model.number="account.amount"
                                                                        :addon-before="settingsData.Currency"
                                                                    />
                                                                </a-input-group>
                                                            </template>

                                                            <template v-else>
                                                                <h6
                                                                    class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font"
                                                                >
                                                                    Account Name
                                                                </h6>
                                                                <a-input
                                                                    v-model="account.account_name"
                                                                    :disabled="loading"
                                                                    type="number"
                                                                    class="ml-1"
                                                                    :style="[cursorDisabled]"
                                                                    size="large"
                                                                />
                                                            </template>
                                                        </div>
                                                    </div>

                                                    <div class="d-flex mt-4 px-lg-3 justify-content-start mb-4">
                                                        <button
                                                            type="submit"
                                                            v-if="!!settingsData.AccountName"
                                                            :disabled="loading"
                                                            :style="[cursorDisabled]"
                                                            style="white-space:nowrap"
                                                            class="py-2 px-3 border-0 kova-bg text-white rounded font-weight-bolder ctrl-font pointer"
                                                        >
                                                            {{ loading ? 'Submitting...' : 'Submit' }}
                                                        </button>
                                                        <button
                                                            type="submit"
                                                            v-else
                                                            :disabled="loading"
                                                            style="white-space:nowrap"
                                                            :style="[cursorDisabled]"
                                                            class="py-2 px-3 border-0 kova-bg text-white rounded font-weight-bolder ctrl-font pointer"
                                                        >
                                                            {{ loading ? 'Saving...' : 'Save' }}
                                                        </button>
                                                        <!-- <button type="reset" :disabled="loading" class=" border-0 font-weight-bolder bg-light py-2 px-3 rounded ctrl-font ml-3 pointer">Cancel</button> -->
                                                    </div>
                                                </form>
                                            </div>
                                            <div class="col-12 col-md-12 col-lg-1 bg-white"></div>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-12 col-lg-6 bg-light border border-top-0 d-none">
                                        <div class="my-4">
                                            <div class="d-flex">
                                                <div class="text-left mr-auto">
                                                    <h6 class="font-weight-bolder text-left">Crypto</h6>
                                                </div>
                                                <div>
                                                    <div class="input-group mb-3">
                                                        <input
                                                            type="button"
                                                            value="Add new address"
                                                            class="btn-kovatek new-bank py-1 px-3"
                                                        />
                                                        <div
                                                            class="input-group-append btn-kovatek plus-btn-icon py-1 px-2"
                                                        >
                                                            <a-icon
                                                                type="plus"
                                                                style="position: relative;bottom: -3px;"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="px-1 px-md-3 ">
                                                <h6
                                                    class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font"
                                                >
                                                    Wallet Address
                                                </h6>
                                                <a-input
                                                    size="large"
                                                    class="ml-1 font-weight-bolder"
                                                    v-model="walletAddress"
                                                />
                                            </div>
                                        </div>
                                        <div class="d-flex mt-4 px-lg-3 justify-content-start mb-4">
                                            <button
                                                class="py-2 px-3 kova-bg border-0 text-white rounded font-weight-bolder ctrl-font pointer"
                                                style="white-space:nowrap"
                                                :style="[cursorDisabled]"
                                            >
                                                Save changes
                                            </button>
                                            <button
                                                :style="[cursorDisabled]"
                                                class="font-weight-bolder bg-light py-2 px-3 rounded ctrl-font ml-3 pointer mr-auto"
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                class="py-2 px-3 light-blue border-0 kova-text rounded font-weight-bolder ctrl-font pointer"
                                                style="white-space:nowrap"
                                                :style="[cursorDisabled]"
                                            >
                                                Delete
                                            </button>
                                        </div>
                                    </div>

                                    <div
                                        class="col-12 col-md-12 col-lg-6 bg-light border border-top-0 crypto-img text-center"
                                    >
                                        <h4 class="my-4">Withdraw Bitcoin</h4>
                                        <img src="@/assets/img/withdraw.svg" />
                                        <p class="mt-3">We will notify when it is live</p>
                                    </div>
                                </div>
                            </div>
                        </a-tab-pane>
                        <a-tab-pane tab="Notifications" :key="4" forceRender>
                            <!-- <input type="checkbox" id="id-name--1" name="set-name" class="switch-input" checked>
                  <label for="id-name--1" class="switch-label">  -->
                            <!-- <span class="toggle--on">On</span><span class="toggle--off">Off</span> -->
                            <!-- </label> -->
                            <div class="mt-4">
                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <form @submit.prevent="updateNotifications">
                                            <div class="border add-rounded p-4">
                                                <h6 class="font-weight-bolder text-left mb-4">
                                                    Activities
                                                </h6>
                                                <div class="d-flex mt-2">
                                                    <div class="mr-auto">
                                                        <p class="kova-light ctrl-font">
                                                            Comments added to ongoing projects
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <input
                                                            type="checkbox"
                                                            id="id-name--1"
                                                            name=""
                                                            :style="[cursorDisabled]"
                                                            class="switch-input"
                                                            v-model="settingsData.ActCommentOngoingProject"
                                                        />
                                                        <label for="id-name--1" class="switch-label my-0 py-0"> </label>
                                                    </div>
                                                </div>
                                                <div class="d-flex mt-2">
                                                    <div class="mr-auto">
                                                        <p class="kova-light ctrl-font">
                                                            Milestone added to an ongoing project
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <input
                                                            type="checkbox"
                                                            id="id-name--2"
                                                            name=""
                                                            :style="[cursorDisabled]"
                                                            class="switch-input"
                                                            v-model="settingsData.ActMilestoneAdded"
                                                        />
                                                        <label for="id-name--2" class="switch-label my-0 py-0"> </label>
                                                    </div>
                                                </div>
                                                <div class="d-flex mt-2">
                                                    <div class="mr-auto">
                                                        <p class="kova-light ctrl-font">
                                                            New Project uploaded
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <input
                                                            type="checkbox"
                                                            id="id-name--3"
                                                            name=""
                                                            class="switch-input"
                                                            :style="[cursorDisabled]"
                                                            v-model="settingsData.ActNewProjectUploaded"
                                                        />
                                                        <label for="id-name--3" class="switch-label my-0 py-0"> </label>
                                                    </div>
                                                </div>
                                                <div class="d-flex mt-2">
                                                    <div class="mr-auto">
                                                        <p class="kova-light ctrl-font">
                                                            Added as a new member to a project
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <input
                                                            type="checkbox"
                                                            id="id-name--4"
                                                            name=""
                                                            :style="[cursorDisabled]"
                                                            class="switch-input"
                                                            v-model="settingsData.ActAddedAsMember"
                                                        />
                                                        <label for="id-name--4" class="switch-label my-0 py-0"> </label>
                                                    </div>
                                                </div>
                                                <div class="d-flex mt-2">
                                                    <div class="mr-auto">
                                                        <p class="kova-light ctrl-font">
                                                            Milestone approved
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <input
                                                            type="checkbox"
                                                            id="id-name--5"
                                                            name=""
                                                            class="switch-input"
                                                            v-model="settingsData.ActMilestoneApproved"
                                                        />
                                                        <label for="id-name--5" class="switch-label my-0 py-0"> </label>
                                                    </div>
                                                </div>
                                                <div class="d-flex mt-4 px-lg-3 justify-content-start">
                                                    <button
                                                        type="submit"
                                                        :disabled="loading"
                                                        style="white-space:nowrap"
                                                        class="py-2 px-3 border-0 kova-bg text-white rounded font-weight-bolder ctrl-font pointer"
                                                    >
                                                        {{ loading ? 'Saving...' : 'Save changes' }}
                                                    </button>
                                                    <!-- <button type="reset" :disabled="loading" class=" border-0 font-weight-bolder bg-light py-2 px-3 rounded ctrl-font ml-3 pointer">Cancel</button> -->
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <form @submit.prevent="updateNotifications">
                                            <div class="border add-rounded p-4">
                                                <h6 class="font-weight-bolder text-left mb-4">
                                                    Emails
                                                </h6>

                                                <div class="d-flex mt-2">
                                                    <div class="mr-auto">
                                                        <p class="kova-light ctrl-font">
                                                            Kovatek Weekly Newsletters
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <input
                                                            type="checkbox"
                                                            id="id-name--6"
                                                            name=""
                                                            class="switch-input"
                                                            v-model="settingsData.EmailNewsletter"
                                                        />
                                                        <label for="id-name--6" class="switch-label my-0 py-0"> </label>
                                                    </div>
                                                </div>
                                                <div class="d-flex mt-2">
                                                    <div class="mr-auto">
                                                        <p class="kova-light ctrl-font">Payment Receipts</p>
                                                    </div>
                                                    <div>
                                                        <input
                                                            type="checkbox"
                                                            id="id-name--7"
                                                            name=""
                                                            class="switch-input"
                                                            v-model="settingsData.EmailPaymentReceipt"
                                                        />
                                                        <label for="id-name--7" class="switch-label my-0 py-0"> </label>
                                                    </div>
                                                </div>
                                                <div class="d-flex mt-2">
                                                    <div class="mr-auto">
                                                        <p class="kova-light ctrl-font">
                                                            New Project uploaded
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <input
                                                            type="checkbox"
                                                            id="id-name--8"
                                                            name=""
                                                            class="switch-input"
                                                            v-model="settingsData.EmailNewProjectUploaded"
                                                        />
                                                        <label for="id-name--8" class="switch-label my-0 py-0"> </label>
                                                    </div>
                                                </div>
                                                <div class="d-flex mt-2">
                                                    <div class="mr-auto">
                                                        <p class="kova-light ctrl-font">
                                                            Added as a new member to a project
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <input
                                                            type="checkbox"
                                                            id="id-name--9"
                                                            name=""
                                                            class="switch-input"
                                                            v-model="settingsData.EmailNewMemberAdded"
                                                        />
                                                        <label for="id-name--9" class="switch-label my-0 py-0"> </label>
                                                    </div>
                                                </div>
                                                <div class="d-flex mt-2">
                                                    <div class="mr-auto">
                                                        <p class="kova-light ctrl-font">
                                                            Milestone approved
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <input
                                                            type="checkbox"
                                                            id="id-name--10"
                                                            name=""
                                                            class="switch-input"
                                                            v-model="settingsData.EmailMilestoneApproved"
                                                        />
                                                        <label for="id-name--10" class="switch-label my-0 py-0">
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="d-flex mt-4 px-lg-3 justify-content-start">
                                                    <button
                                                        type="submit"
                                                        :disabled="loading"
                                                        style="white-space:nowrap"
                                                        class="py-2 px-3 border-0 kova-bg text-white rounded font-weight-bolder ctrl-font pointer"
                                                    >
                                                        {{ loading ? 'Saving...' : 'Save changes' }}
                                                    </button>
                                                    <!-- <button type="reset" :disabled="loading" class=" border-0 font-weight-bolder bg-light py-2 px-3 rounded ctrl-font ml-3 pointer">Cancel</button> -->
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </a-tab-pane>
                        <a-tab-pane tab="Account" :key="5">
                            <div class="mt-4">
                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <div class="border add-rounded p-4">
                                            <!-- <h6 class="font-weight-bolder text-left mb-4">Change Password</h6> -->
                                            <form @submit.prevent="updateAccount">
                                                <div>
                                                    <h6
                                                        class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font"
                                                    >
                                                        Preferred Language
                                                    </h6>
                                                    <div>
                                                        <a-select
                                                            :disabled="loading"
                                                            class="w-100 ctrl-font"
                                                            :style="[cursorDisabled]"
                                                            style="font-size: 16px;"
                                                            size="large"
                                                            placeholder="Enter/Choose skills"
                                                            v-model="settingsData.Language"
                                                        >
                                                            <a-select-option v-for="lang in languages" :key="lang">
                                                                {{ lang }}
                                                            </a-select-option>
                                                        </a-select>
                                                    </div>
                                                </div>

                                                <!-- <div class="row">
                            <div class="col-sm-9 col-lg-8"> -->
                                                <!-- <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font">Price Range (per hour)</h6>
                              <div>
                                <a-select class="w-100 ctrl-font" size="large" placeholder="Select Price Range" v-model="settingsData.Rating">
                                  <a-select-option :key="id+'rate'" v-for="{ id, level, work_rate } in levels" :value="id">
                                    {{ `${work_rate}/hr (${level})` }}
                                  </a-select-option>
                                </a-select>
                              </div>
                              {{ profileData.WorkRate }}
                            </div> -->
                                                <div>
                                                    <h6
                                                        class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font"
                                                    >
                                                        Preferred Currency
                                                    </h6>
                                                    <div class="d-flex">
                                                        <!-- <a-input size="large" class="ml-1 font-weight-bolder" v-model="settingsData.Currency" /> -->
                                                        <a-select
                                                            :disabled="loading"
                                                            class="w-75 ctrl-font"
                                                            style="font-size: 16px;"
                                                            size="large"
                                                            @change="getCurrencyUSDValue($event)"
                                                            show-search
                                                            :style="[cursorDisabled]"
                                                            placeholder="Select Currency"
                                                            v-model="settingsData.Currency"
                                                        >
                                                            <a-select-option
                                                                v-for="{ currency, name } in filteredCurrencies"
                                                                :key="currency + name"
                                                                :value="currency"
                                                            >
                                                                {{ name }} ({{ currency }})
                                                            </a-select-option>
                                                        </a-select>
                                                        <div
                                                            class="kova-bg-green py-2 px-2 rounded ml-2 text-white"
                                                            style="white-space: nowrap"
                                                            v-if="settingsData.Currency !== 'USD'"
                                                        >
                                                            {{ exchangeRate ? USDRate : '...' }}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="text-left">
                                                    <h6
                                                        class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font"
                                                    >
                                                        Hourly Rate
                                                    </h6>
                                                    <div class="d-flex">
                                                        <a-input
                                                            :disabled="loading"
                                                            type="number"
                                                            class="w-75"
                                                            size="large"
                                                            :min="Number(rates[0])"
                                                            :max="Number(rates[1])"
                                                            placeholder="0"
                                                            v-model.number="settingsData.HourRate"
                                                            addon-before="$"
                                                            :style="[cursorDisabled]"
                                                            addon-after="/hr"
                                                        />
                                                        <router-link
                                                            to="/devsignup/overview"
                                                            class="kova-bg-green py-2 px-2 rounded ml-2 text-white"
                                                            style="white-space: nowrap"
                                                        >
                                                            Upgrade Level
                                                        </router-link>
                                                    </div>
                                                    <span class="kova-text">
                                                        <a-icon type="info-circle" /> The price range for
                                                        {{ profileLevel }} developers is {{ workrate }}</span
                                                    >
                                                </div>

                                                <div>
                                                    <h6
                                                        class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font"
                                                    >
                                                        Tell a Friend
                                                    </h6>
                                                    <div>
                                                        <a-input
                                                            size="large"
                                                            class="ml-1 font-weight-bolder"
                                                            v-model="settingsData.InviteLink"
                                                            :style="[cursorDisabled]"
                                                            id="profileLink"
                                                        >
                                                            <a-tooltip
                                                                slot="suffix"
                                                                :title="
                                                                    !copied ? 'click to copy' : 'copied to clipboard'
                                                                "
                                                            >
                                                                <span
                                                                    class="pointer ant-color font-weight-lighter"
                                                                    @mouseover="copied = false"
                                                                    @click="copy(settingsData.InviteLink)"
                                                                >
                                                                    copy
                                                                </span>
                                                            </a-tooltip>
                                                        </a-input>
                                                    </div>
                                                </div>

                                                <div class="mt-3 kova-text d-flex">
                                                    <p class="font-weight-bolder ml-3 pointer">
                                                        <a-icon
                                                            type="question-circle"
                                                            class="pointer mr-1"
                                                            theme="filled"
                                                            style="font-size: 20px; position: relative; bottom: 2px"
                                                        />
                                                        Help
                                                    </p>
                                                    <p class="font-weight-bolder ml-4 pointer">
                                                        <font-awesome-icon
                                                            icon="comment-alt"
                                                            class="pointer mr-1"
                                                            style="font-size: 20px; position: relative; bottom: -2px"
                                                        />
                                                        Send Feedback
                                                    </p>
                                                </div>

                                                <div class="d-flex mt-5 px-lg-3 justify-content-start">
                                                    <button
                                                        type="submit"
                                                        :disabled="loading"
                                                        style="white-space:nowrap"
                                                        class="py-2 px-3 border-0 kova-bg text-white rounded font-weight-bolder ctrl-font pointer"
                                                    >
                                                        {{ loading ? 'Saving...' : 'Save changes' }}
                                                    </button>
                                                    <button
                                                        type="reset"
                                                        :disabled="loading"
                                                        class=" border-0 font-weight-bolder bg-light py-2 px-3 rounded ctrl-font ml-3 pointer"
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-6 col-lg-6"></div>
                                </div>
                            </div>
                        </a-tab-pane>
                    </a-tabs>
                </div>
            </div>
        </div>
        <!-- {{res}} -->
        <Footers />
    </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Footers from '@/components/Footer.vue';
import countries from '../data/countries.json';
import { currencies } from '../data/utils';
import Axios from 'axios';
import { levels } from '../data/resources';
import { convertCurrency } from '../utils';

import ProfileMixin from '../mixins/profile';

function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
}

export default {
    name: 'settings',
    mixins: [ProfileMixin],
    components: {
        Navbar,
        Footers,
    },
    data() {
        return {
            loading: false,
            imageUrl: '',
            languages: ['English'],
            emailVerified: false,
            phoneVerified: false,
            walletAddress: 'Sadbsajgduqe82ey23ey230ee',
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            // profileLink: 'https://kovatek.com/mike/invite',
            ActivitiesPaymentReceipt: false,
            ActivitiesNewProjectUploaded: false,
            ActivitiesMilestoneApproved: false,
            ActivitiesNewMemberAdded: false,
            settingsData: {},
            profileData: {},
            message: '',
            error: '',
            wallet: {},
            activeKey: 1,
            account: {},
            exchangeRate: null,
            banks: [],
        };
    },
    computed: {
        inputtedUsername: {
            set(value) {
                this.settingsData.Username = value;
            },
            get() {
                return this.settingsData.Username;
            },
        },
        userUsesGithubName() {
            const username = this.settingsData.Username || '';
            return username == this.githubName;
        },
        cursorDisabled() {
            return this.loading && { cursor: 'not-allowed' };
        },
        USDRate() {
            return `$1 = ${this.settingsData.Currency}${this.exchangeRate}`;
        },
        filteredCurrencies() {
            return currencies.filter(
                key => ['KES', 'NGN'].includes(key.currency) || key.name.includes('United States of America'),
            );
        },
        states() {
            const country = countries.find(key => key.name === this.settingsData.Country);
            return country ? country.states : [];
        },
        githubName() {
            return (this.profileData.GithubLink || '').replace(/github.com\//g, '');
        },
        workrate() {
            if (this.settingsData.HourRate && !this.$route.path.includes('settings')) {
                return `Hourly Rate: $${this.settingsData.HourRate}`;
            }

            return levels.find(key => key.id == this.profileData.WorkRate)?.work_rate;
        },
        rates() {
            if (!this.workrate) {
                return [5, 50];
            }

            return (this.workrate || '')
                .replace(/\$/g, '')
                .replace(/ /g, '')
                .split('-');
        },
    },
    methods: {
        callback(event) {
            this.activeKey = event;
        },
        beforeUpload({ type, size }) {
            const isAllowed = ['image/jpeg', 'image/png', 'image/jpg'].includes(type);
            if (!isAllowed) {
                this.showError('', 'You can only upload JPG or PNG files!');
            }

            const isLessthan3M = size / 1024 / 1024 < 3;
            if (!isLessthan3M) {
                this.showError('', 'Image must smaller than 3MB!');
            }

            return isAllowed && isLessthan3M;
        },
        goback: () => {
            this.$router.back();
        },
        upload({ file }) {
            getBase64(file.originFileObj, imageUrl => {
                this.imageUrl = imageUrl;
                this.loading = false;
                this.updateAvatar(file.originFileObj);
            });
        },
        getAllSettings() {
            this.$store
                .dispatch('settings/userSettings')
                .then(resp => {
                    this.settingsData = { ...resp.data, Language: resp.data.Language || 'English' };
                    this.imageUrl = resp.data.AvatarHref;

                    this.account.currency = this.settingsData.Currency;

                    // const country = countries.find(key => key.name === this.profileData.Country);
                    // if (country) await this.getAllBanks(country.iso2);
                    this.$store.commit('setLoader', false);
                })
                .catch(err => {
                    this.message = err;
                });
        },
        updateSettings(user) {
            this.$store.commit('setLoader', true);
            this.$store
                .dispatch('settings/updateSettings', user)
                .then(resp => {
                    this.getAllSettings();
                    this.showToast(`Your ${user.type} settings has been updated!`);
                    this.$store.commit('setLoader', false);
                })
                .catch(err => {
                    this.catchErrors(err);
                });
        },

        updateProfile() {
            const { Firstname, Username, Surname, Email, Phone } = this.settingsData;
            const { City, Country } = this.profileData;

            const error = !Username
                ? 'Please enter your username!'
                : !Firstname
                ? 'Please enter your first name!'
                : !Surname
                ? 'Please enter your surname!'
                : !Email || !this.validateEmail(Email)
                ? 'Please enter a valid e-mail address!'
                : !Phone
                ? 'Please enter your phone number!'
                : !Country
                ? 'Please enter your country of residence!'
                : !City
                ? 'Please enter your city of residence!'
                : '';

            if (error.length) return this.showError('', error);

            const phoneCode = String(Phone).slice(1, 4);
            const findCountry = countries.find(key => key.name === Country);
            const countryCode = findCountry.phone_code;

            if (phoneCode.slice(0, countryCode.length) !== countryCode) {
                return this.showError(
                    'Invalid Phone Number',
                    `${Country}, your country of residence, does not use that phone code!`,
                );
            }

            const user = {
                type: 'profile',
                data: { Firstname, Surname, Username, Email, Phone, City, Country },
            };
            this.updateSettings(user);
        },
        async updateAvatar(file) {
            const id = localStorage.getItem('id');
            const token = localStorage.getItem('token');

            const formData = new FormData();
            formData.append('avatar', file);

            try {
                await this.$api({
                    url: `/settings/${id}/avatar`,
                    method: 'put',
                    data: formData,
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                this.showToast('Your avatar has been changed!');
                // this.settingsData.Avatar = res.data;
            } catch (err) {
                this.catchErrors(err);
            }
        },
        async getCurrencyUSDValue(currency) {
            if (currency !== 'USD') {
                this.exchangeRate = await convertCurrency('USD', currency);
            }
        },
        async deleteAvatar() {
            const vm = this;

            const id = localStorage.getItem('id');
            const token = localStorage.getItem('token');
            try {
                const res = await vm.$api({
                    url: `/settings/${id}/avatar`,
                    method: 'delete',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (res.status) {
                    vm.showToast('Your avatar has been removed');
                    vm.imageUrl = '';
                }
            } catch (err) {
                vm.catchErrors(err);
            }
        },
        validateNumbers: value => /^\d+$/.test(value),
        saveAccount() {
            const { account_number, account_name, account_bank } = this.account;
            const error =
                !account_number || account_number.length !== 10 || !this.validateNumbers(account_number)
                    ? 'Account Number must have 10 numbers'
                    : !account_name
                    ? 'Enter the name of the account'
                    : !account_bank
                    ? 'Select the bank associated to this acounnt'
                    : '';

            if (error.length) return this.showError('', error);

            const user = {
                type: 'payment',
                data: {
                    AccountName: account_name,
                    AccountNumber: account_number,
                    BankName: account_bank,
                },
            };
            this.updateSettings(user);
        },

        updateAccount() {
            const { Language, Currency, HourRate } = this.settingsData;

            const error = !Language
                ? 'Please select your preferred language!'
                : !HourRate || HourRate < this.rates[0] || HourRate > this.rates[1]
                ? `Please enter your desired hourly rate between $${this.rates[0]} - $${this.rates[1]}`
                : !Currency
                ? 'Please select your preferred currency'
                : '';

            if (error.length) return this.showError('', error);

            const user = {
                type: 'account',
                data: {
                    language: Language,
                    hour_rate: HourRate,
                    currency: Currency,
                },
            };
            this.updateSettings(user);
        },
        showPhone(val) {
            console.log(val);
        },
        updateNotifications() {
            const {
                EmailNewsletter: email_newsletter,
                EmailPaymentReceipt: email_payment_receipt,
                EmailNewProjectUploaded: email_new_project_uploaded,
                EmailMilestoneApproved: email_milestone_approved,
                EmailNewMemberAdded: email_new_member_added,
                ActCommentOngoingProject: act_comment_ongoing_project,
                ActMilestoneAdded: act_milestone_added,
                ActNewProjectUploaded: act_new_project_uploaded,
                ActMilestoneApproved: act_milestone_approved,
                ActAddedAsMember: act_added_as_member,
            } = this.settingsData;

            const user = {
                type: 'notification',
                data: {
                    email_newsletter,
                    email_payment_receipt,
                    email_new_project_uploaded,
                    email_milestone_approved,
                    email_new_member_added,
                    act_comment_ongoing_project,
                    act_milestone_added,
                    act_new_project_uploaded,
                    act_milestone_approved,
                    act_added_as_member,
                },
            };

            this.updateSettings(user);
        },

        updatePassword() {
            const isValid =
                this.newPassword !== this.confirmPassword || this.newPassword === '' || this.confirmPassword === '';

            if (!isValid) {
                const data = {
                    old_password: this.oldPassword,
                    new_password: this.newPassword,
                };

                this.$store
                    .dispatch('settings/updatePassword', data)
                    .then(resp => {
                        this.message = resp.data;
                        this.$store.commit('setLoader', false);
                        this.showToast('Your password has been changed!');
                    })
                    .catch(err => {
                        this.catchErrors(err);
                    });
            } else {
                this.error = 'invalid or incomplete inputs';
            }
        },
        onLoad() {
            const { type } = this.$route.query;
            if (type && type.includes('payment')) this.activeKey = 3;
            else this.activeKey = 1;
        },
        withdraw() {
            if (!this.settingsData.AccountName) return this.saveAccount();

            const { amount, account_number, account_bank, currency } = this.account;

            const error = !account_bank
                ? 'Please select a bank'
                : !account_number || account_number.length !== 10
                ? 'Please enter a valid bank account number'
                : !currency
                ? 'Please select your preferred currency'
                : !amount || amount < 1e3
                ? 'The lowest amount you can withdraw is N1,000'
                : amount > 1e6
                ? `The maximum amount for withdrawal is ${this.formatAmount(1e6)}`
                : '';

            if (error.length) return this.showError('', error);

            const payload = {
                account_bank,
                account_number,
                amount,
                currency,
            };

            this.submitWithdrawalRequest(payload);
        },
        async submitWithdrawalRequest(data) {
            const token = localStorage.getItem('token');

            try {
                await this.$api({
                    url: `/payments/withdraw`,
                    method: 'post',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    data,
                });

                const text = 'Your withdrawal request has been sent. Your account will be funded in a short while!';
                this.showNotification('success', text, 'Successful');
            } catch (err) {
                this.catchErrors(err);
            }
        },
        async getWallets() {
            const token = localStorage.getItem('token');

            try {
                const res = await this.$api({
                    url: `/wallets`,
                    method: 'get',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                this.wallet = res.data;
            } catch (err) {
                this.catchErrors(err);
            }
        },
        getAllBanks(country) {
            try {
                const res = Axios({
                    url: `https://api.flutterwave.com/v3/banks/${country}`,
                    headers: {
                        Authorization: `Bearer ${process.env.VUE_APP_FLUTTERWAVE_SECRET_KEY}`,
                    },
                    credentials: 'include',
                });
                console.log(res.data);
            } catch (e) {
                this.catchErrors(e);
            }
        },
        onChange() {
            if (!this.userUsesGithubName) {
                this.settingsData.Username = this.githubName;
                return;
            }

            this.settingsData.Username = '';
        },
    },
    async mounted() {
        this.onLoad();
        this.$store.commit('setLoader', true);
        await Promise.all([
            this.getProfile(),
            // this.getWallets(),
            this.getAllSettings(),
        ]);
    },
    watch: {
        $route: 'onLoad',
    },
};
</script>

<style scoped>
.kova-width {
    max-width: 1350px;
    margin: auto;
}
.img-height {
    width: 160px;
    height: 160px;
}
.ctrl-font {
    font-size: 11px;
}
.ctrl-font-2 {
    font-size: 13px;
}
.new-bank {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
}
.plus-btn-icon {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    border-left: solid 1px #fff;
}

/* styling switch */

.switch-input {
    display: none;
}
.switch-label {
    position: relative;
    display: inline-block;
    min-width: 50px;
    cursor: pointer;
    font-weight: 500;
    text-align: left;
    margin: 16px;
    padding: 16px 0 16px 44px;
}
.switch-label:before,
.switch-label:after {
    content: '';
    position: absolute;
    margin: 0;
    outline: 0;
    top: -7px;
    -ms-transform: translate(0, -50%);
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -50%);
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
}
.switch-label:before {
    left: 1px;
    width: 34px;
    height: 14px;
    background-color: #cbcbcb;
    border-radius: 8px;
}
.switch-label:after {
    left: 0;
    width: 20px;
    height: 20px;
    background-color: #fafafa;
    border-radius: 50%;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.14), 0 2px 2px 0 rgba(0, 0, 0, 0.098), 0 1px 5px 0 rgba(0, 0, 0, 0.084);
}
/* .switch-label .toggle--on {
  display: none;
}
.switch-label .toggle--off {
  display: inline-block;
} */
.switch-input:checked + .switch-label:before {
    background-color: rgba(32, 64, 154, 0.25);
}
.switch-input:checked + .switch-label:after {
    background-color: #20409a;
    -ms-transform: translate(80%, -50%);
    -webkit-transform: translate(80%, -50%);
    transform: translate(80%, -50%);
}
/* .switch-input:checked + .switch-label .toggle--on {
  display: inline-block;
}
.switch-input:checked + .switch-label .toggle--off {
  display: none;
} */

.crypto-img img {
    height: 200px;
}
</style>
